module.exports = __webpack_public_path__ + "img/nj.66a2a9e4.png";